import * as SignalR from '@microsoft/signalr';
import chromeExAPI from '@/chromeExAPI';
import { getActiveWorks } from '@/utils/workIdManager';

let ws = null;
let url = null;
let heartbeatInterval = null;

let imageLoadCallback = function imageLoadCallback(base64Wemp, x, y, type) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = function() {
      let canvas = document.createElement('canvas');
      canvas.width = x == -1 ? img.width : x;
      canvas.height = y == -1 ? img.height : y;
      let context = canvas.getContext('2d');
      let mimeType = 'image/' + (type == 'jpg' ? 'jpeg' : type);

      // JPEG는 투명도를 지원하지 않아, 투명 WebP를 그대로 변환하면 투명 픽셀이 검정으로 채워짐.
      // drawImage 전에 흰 배경을 먼저 깔아 검정 배경 버그를 방지. (PNG는 투명도 보존을 위해 제외)
      if (mimeType === 'image/jpeg') {
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, canvas.width, canvas.height);
      }
      context.drawImage(img, 0, 0, x == -1 ? img.width : x, y == -1 ? img.height : y);
      let dataurl = mimeType === 'image/jpeg' ? canvas.toDataURL(mimeType, 0.95) : canvas.toDataURL(mimeType);
      resolve(dataurl);
    };
    img.onerror = function() {
      reject(base64Wemp);
    };
    img.src = base64Wemp;
  });
};

// Heartbeat 시작 함수
function startHeartbeat(connection, vueInstance) {
  // 기존 interval 정리
  stopHeartbeat();

  // 30초마다 Heartbeat 전송
  heartbeatInterval = setInterval(() => {
    if (connection && connection.state === 'Connected') {
      const tabId = getTabId();
      if (!tabId) {
        console.error('Heartbeat: tabId가 없습니다.');
        return;
      }
      connection.invoke('Heartbeat', tabId)
        .catch(err => {
          console.error('Heartbeat 전송 실패:', err);
          // Heartbeat 실패 시 연결 상태 확인 및 재연결 시도
          if (vueInstance && vueInstance.ws_connect) {
            console.log('연결 끊김 감지, 재연결 시도...');
            stopHeartbeat();
            // 재연결 시도
            setTimeout(() => {
              if (vueInstance.$ws?.state !== 'Connected') {
                vueInstance.ws_connect();
              }
            }, 1000);
          }
        });
    } else {
      // 연결이 끊어진 경우 interval 정리
      stopHeartbeat();
    }
  }, 60000); // 1분마다
}
// Heartbeat 중지 함수
function stopHeartbeat() {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
}
// 재접속 처리 함수
async function handleReconnection(connection) {
  try {
    // localStorage에서 활성 작업 ID 목록 가져오기
    const activeWorks = getActiveWorks();

    if (activeWorks.length > 0 && connection) {
      // 백엔드에 재접속 알림 및 작업 ID 목록 전송
      await connection.invoke('NotifyReconnection', activeWorks).catch(err => {
        console.error('재접속 알림 전송 실패:', err);
      });
      console.log(`재접속 알림 전송: ${activeWorks.length}개 작업`);
    }
  } catch (error) {
    console.error('재접속 처리 오류:', error);
  }
}

function getTabId() {
  // 1. window.name 확인 (탭 고유값)
  if (!window.name) {
    window.name = crypto.randomUUID();
  }

  let tabId = sessionStorage.getItem('tabId');
  console.log(`TabId: ${tabId}`);

  // 2. sessionStorage 없으면 생성
  if (!tabId) {
    tabId = window.name;
    sessionStorage.setItem('tabId', tabId);
    return tabId;
  }

  // 3. 복제 탭 감지 (핵심🔥)
  if (tabId !== window.name) {
    tabId = window.name;
    sessionStorage.setItem('tabId', tabId);
  }

  return tabId;
}

export { getTabId };

export default {

  install(Vue) {
    url = process.env.VUE_APP_TEST_SOCKET_URL;

    if (['https://omarket.kr', 'https://api.omarket.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_SOCKET_URL;
    } else if (['https://shcolab.co.kr', 'https://api.shcolab.co.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_SHCOLAB_SOCKET_URL;
    } else if (['https://daenlabs.kr', 'https://api.daenlabs.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_DAENLABS_SOCKET_URL;
    } else if (['https://kimmanager.co.kr', 'https://api.kimmanager.co.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_KIMMANAGER_SOCKET_URL;
    } else if (['https://kcode.store', 'https://api.kcode.store'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_KCODE_SOCKET_URL;
    } else if (['https://withjikkoo.kr', 'https://api.withjikkoo.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_WITHJIKKOO_SOCKET_URL;
    } else if (['https://crosssell.co.kr', 'https://apiv2.omarket.kr', 'https://magicone.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_CROSSSELL_SOCKET_URL;
    } else if (['https://overlink.kr', 'https://api.overlink.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_OVERWAY_SOCKET_URL;
    } else if (['https://zijyasssssell.com', 'https://api.zijyasssssell.com'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_ZIJYASSSSSELL_SOCKET_URL;
    } else if (['https://cospia.net'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_OSONUPLOAD_SOCKET_URL;
    } else if (['https://smartcross.kr', 'https://api.smartcross.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_SMARTCROSS_SOCKET_URL;
    } else if (['https://stock.overlink.kr'].includes(window.location.origin)) {
      url = process.env.VUE_APP_PRODUCT_STOCK_SOCKET_URL;
    } else if (['https://localhost:8080'].includes(window.location.origin)) {
      url = process.env.VUE_APP_TEST_SOCKET_URL;
    } else {
      url = process.env.VUE_APP_TEST_SOCKET_URL;
    }

    Vue.prototype.ws_connect = function() {
      if (this.$ws?.connection?._connectionState == 'Connected') {
        console.log('연결 되어있음');
        return;
      }

      // 도메인이 cospia.net이면 VUE_APP_PRODUCT_OSONUPLOAD_SOCKET_URL 사용
      // (magicone.kr은 apiv2 백엔드를 사용하므로 위에서 결정된 url(=apiv2 chathub)을 그대로 사용)
      let socketUrlToUse = url;
      if (window.location.hostname === 'cospia.net' || window.location.hostname.includes('cospia.net')) {
        socketUrlToUse = process.env.VUE_APP_PRODUCT_OSONUPLOAD_SOCKET_URL;
        console.log('[WebSocket] 테스트서버 cospia.net 도메인 감지, OSONUPLOAD Socket URL 사용:', socketUrlToUse);
      }
      // smartcross.kr 은 자체 백엔드(api.smartcross.kr)를 쓰므로 SMARTCROSS Socket URL 사용
      else if (window.location.hostname === 'smartcross.kr' || window.location.hostname.includes('smartcross.kr')) {
        socketUrlToUse = process.env.VUE_APP_PRODUCT_SMARTCROSS_SOCKET_URL;
        console.log('[WebSocket] smartcross.kr 도메인 감지, SMARTCROSS Socket URL 사용:', socketUrlToUse);
      }
      // kimmanager 도메인은 항상 KIMMANAGER Socket URL 사용
      else if (window.location.hostname === 'kimmanager.co.kr' || window.location.hostname === 'api.kimmanager.co.kr') {
        socketUrlToUse = process.env.VUE_APP_PRODUCT_KIMMANAGER_SOCKET_URL;
        console.log('[WebSocket] kimmanager 도메인 감지, KIMMANAGER Socket URL 사용:', socketUrlToUse);
      }
      // stock.overlink.kr 도메인은 항상 STOCK Socket URL 사용
      else if (window.location.hostname === 'stock.overlink.kr') {
        socketUrlToUse = process.env.VUE_APP_PRODUCT_STOCK_SOCKET_URL;
        console.log('[WebSocket] stock.overlink.kr 도메인 감지, STOCK Socket URL 사용:', socketUrlToUse);
      }
      // 로그인한 서버의 socketUrl이 있으면 우선 사용 (로드밸런싱 대응)
      else if (this.authStore.socketUrl) {
        socketUrlToUse = this.authStore.socketUrl;
        console.log('[WebSocket] 로그인한 서버의 Socket URL 사용:', socketUrlToUse);
      }

      // socketUrl에서 serverId 추출 또는 authStore에서 가져오기
      let serverId = this.authStore.serverId || localStorage.getItem('serverId');

      // socketUrl에 serverId가 없고, 추출한 serverId가 있으면 URL에 추가
      if (serverId) {
        try {
          const urlObj = new URL(socketUrlToUse);
          // 이미 serverId가 URL에 포함되어 있지 않은 경우에만 추가
          if (!urlObj.searchParams.has('serverId')) {
            urlObj.searchParams.set('serverId', serverId);
            socketUrlToUse = urlObj.toString();
            console.log('[WebSocket] ServerId 추가:', serverId);
          } else {
            console.log('[WebSocket] ServerId 이미 URL에 포함됨:', urlObj.searchParams.get('serverId'));
          }
        } catch (error) {
          console.warn('[WebSocket] ServerId 추가 실패:', error);
        }
      } else {
        console.warn('[WebSocket] ServerId를 찾을 수 없습니다.');
      }

      // 최종 연결 URL 로그 출력 (디버깅용)
      // console.log('[WebSocket] 최종 연결 URL:', socketUrlToUse);

      const setupOption = {
        skipNegotiation: true,
        transport: SignalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => this.authStore.user.accessToken,
        headers: { authorization: 'Bearer ' + this.authStore.user.accessToken },
        withCredentials: true
      };
      ws = new SignalR.HubConnectionBuilder()
        .withUrl(socketUrlToUse, setupOption)
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: retryContext => {
            // 재시도 간격: 0초, 2초, 10초, 30초
            if (retryContext.previousRetryCount === 0) return 0;
            if (retryContext.previousRetryCount === 1) return 2000;
            if (retryContext.previousRetryCount === 2) return 10000;
            return 30000;
          }
        })
        .configureLogging(SignalR.LogLevel.Information) // 로깅 설정 (선택 사항)
        .build();

      // 재접속 이벤트 핸들러 설정
      ws.onreconnecting(() => {
        console.log('재접속 중...');
      });

      ws.onreconnected(async (connectionId) => {
        console.log('재접속 완료:', connectionId);
        // 재접속 시 서버가 tabId 매핑을 복구하지 않으므로 RegisterSession 재전송으로 push 라우팅 복구
        const tabId = getTabId();
        try {
          await ws.invoke('RegisterSession', { tabId: tabId });
        } catch (err) {
          console.error('재접속 후 RegisterSession 재등록 실패:', err);
        }
        await handleReconnection(ws, this);
        // Heartbeat 다시 시작
        startHeartbeat(ws, this);
      });

      ws.start()
        .then(async () => {
          // 세션 등록 (매핑 등록 후 작업 복구되도록 await)
          const tabId = getTabId();
          try {
            await ws.invoke('RegisterSession', { tabId: tabId });
          } catch (err) {
            console.error('RegisterSession 등록 실패:', err);
          }

          // Heartbeat 시작
          startHeartbeat(ws, this);
          // 초기 연결 시 재접속 처리 (활성 작업 복구)
          await handleReconnection(ws, this);
        })
        .catch(error => {
          console.error('연결 실패:', error);
        });

      // 연결 종료 시 Heartbeat 정리
      ws.onclose(() => {
        stopHeartbeat();
      });

      Vue.prototype.$ws = ws;

      let events = this.$options['echo'];
      if (!events) {
        return;
      }

      Object.keys(events).forEach(function(key) {
        ws.on(key, async (...args) => {
          try {
            return await events[key].bind(this)(args);
          } catch (e) {
            console.error('error methods setupWs', e);
          }
        });
      }, this);


    };

    Vue.mixin({
      echo: {
        async UserConnected(payload) {
          this.socketStore.setConnectionId(payload[0]);
          // console.log('연결 성공:' + payload);
          // 초기 연결 시 재접속 처리 (활성 작업 복구)
          if (this.$ws && this.$ws.connection?._connectionState === 'Connected') {
            await handleReconnection(this.$ws, this);
            startHeartbeat(this.$ws, this);
          }
        },
        UserDisconnected(payload) {
          this.socketStore.setConnectionId(null);
          // console.log('연결 끊김:' + payload);
        },
        heartbeatreceived(payload) {
          // Heartbeat 수신 확인 (백엔드에서 호출)
          // 연결 상태 유지 확인용으로 사용 가능
          // console.log('Heartbeat received:', payload);
        },
        __validate__(payload) {
          // SignalR 연결 검증 메서드 (백엔드에서 호출)
          // 연결 유효성 검증용으로 사용
          // console.log('Connection validated:', payload);
        },
        async ExtentionsProxy(payload) {
          const method = payload[0];
          const url = payload[1];
          const headers = payload[2];
          const body = payload[3];
          const encodingType = payload[4] || 'UTF-8';

          /*
          console.log(`payload:`);
          console.log(`\tmethod:${method}`);
          console.log(`\turl:${url}`);
          console.log(`\theaders:${headers}`);
          console.log(`\tbody:${body}`);
          console.log(`\tencodingType:${encodingType}`);
          */

          if (payload.length !== 5) {
            console.log('payload Error Length:' + payload.length);
            return;
          }
          if (this.socketStore.connectionId == null) {
            console.log('connection Id null');
            return;
          }
          this.socketStore.proxyRequestModel = payload;
          let responseModel = null;
          switch (method) {
            case 'GET':
              responseModel = await chromeExAPI.GetMethod(url, headers, encodingType); // URL
              break;
            case 'POST':
              responseModel = await chromeExAPI.PostMethod(url, headers, body, encodingType);
              break;
            case 'PUT':
              responseModel = await chromeExAPI.PutMethod(url, headers, body, encodingType);
              break;
            case 'DELETE':
              responseModel = await chromeExAPI.DeleteMethod(url, headers, body, encodingType);
              break;
            case 'PATCH':
              responseModel = await chromeExAPI.PatchMethod(url, headers, body, encodingType);
              break;
            case 'MULITPART':
              responseModel = await chromeExAPI.MultipartMethod(url, headers, body);
              break;
            case 'GetBrowserHtml':
              responseModel = await chromeExAPI.GetBrowserHtmlMethod(url, headers);
              break;
          }
          this.socketStore.proxyResponseModel = responseModel;
          return responseModel;
        },
        async ImageBase64Convert(payload) {
          let item = await chromeExAPI.ImageMethod(payload[0]);
          return item;
        },
        async RequestWebpToJpg(payload) {
          let responseData = {
            body: null,
            headers: null
          };
          try {
            // 크롬 익스텐션에서 응답을 완전히 받을 때까지 대기
            let responseModel = await chromeExAPI.ImageMethod(payload[0]);

            // 응답이 유효한지 확인
            if (!responseModel || !responseModel.body) {
              throw new Error('Invalid response from extension: missing body');
            }

            const type = payload[0].includes('.png') ? 'png' : 'jpg';
            // imageLoadCallback도 완료될 때까지 대기
            const processedBody = await imageLoadCallback(responseModel.body, payload[1], payload[2], type);

            responseData = {
              body: processedBody,
              headers: null
            };
            return responseData;
          } catch (error) {
            console.error('RequestWebpToJpg error:', error);
            // 에러 발생 시에도 응답 구조를 유지하여 백엔드로 전달
            throw error;
          }
        },
        async SetLocalStorage(payload) {
          let response = null;
          try {
            localStorage.setItem(payload[0], payload[1]);
            response = localStorage.getItem(payload[0]);
          } catch (ex) {
            console.log(ex);
          }
          return response;
        },
        async GetLocalStorage(payload) {
          let response = null;
          try {
            response = localStorage.getItem(payload[0]);
          } catch (ex) {
            console.log(ex);
          }
          return response;
        },
        NoticeCollectResult(payload) {
          // console.log('NoticeCollectResult(payload)');
          const data = JSON.parse(payload);

          // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
          if (data.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }

          // 기존 방식 유지 (하위 호환)
          this.socketStore.setCollectList(false, data);
          // this.socketStore.setType('COLLECT');
          this.socketStore.setFinish('');
        },
        NoticeCollectFinish(payload) {
          if (payload[0] === '상품수집 완료') {
            this.socketStore.setFinish('COLLECT');
            this.socketStore.setType('');
            this.socketStore.setProgress('stop');
          }
        },
        NoticeUploadResult(payload) {
          const data = JSON.parse(payload);

          // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
          if (data.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }

          // 기존 방식 유지 (하위 호환)
          this.socketStore.setUploadList(false, data);
          this.socketStore.setType('UPLOAD');
          this.socketStore.setFinish('');
        },
        NoticeMarketProductCollectResult(payload) {
          const raw = Array.isArray(payload) ? payload[0] : payload;
          const data = typeof raw === 'string' ? JSON.parse(raw) : raw;

          // console.log('[NoticeMarketProductCollectResult] data:', data);

          if (data?.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }

          this.socketStore.setMarketProductList(false, data);
        },
        NoticeUploadFinish(payload) {
          if (payload[0] === '상품등록 완료') {
            this.socketStore.setFinish('UPLOAD');
            this.socketStore.setType('');
            this.socketStore.setProgress('stop');
          }
        },
        NoticeStockLinkResult(payload) {
          const data = JSON.parse(payload);

          // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
          if (data.workId && this.socketStore.workIdCallbacks.has(data.workId)) {
            this.socketStore.handleWorkResult(data.workId, data);
          }

          // 기존 방식 유지 (하위 호환)
          this.socketStore.setStockLinkList(false, data);
          this.socketStore.setType('STOCKLINK');
          this.socketStore.setFinish('');
        },
        NoticeStockLinkFinish(payload) {
          if (payload[0] === '재고연동 완료') {
            this.socketStore.setFinish('STOCKLINK');
            this.socketStore.setType('');
            this.socketStore.setProgress('stop');
          }
        },
        async ExtensionsCookie(payload) {
          const res = await chromeExAPI.CheckSiteLogin(payload);
          return res.responseMsg;
        },
        NoticeStatusChangeResult(result) {
          let deleteResult = {};
          result.forEach(res => {
            const parsed = JSON.parse(res);
            deleteResult = { ...deleteResult, ...parsed };

            // 작업 ID가 포함되어 있으면 작업 ID 기반 콜백 호출
            if (parsed.workId && this.socketStore.workIdCallbacks.has(parsed.workId)) {
              this.socketStore.handleWorkResult(parsed.workId, parsed);
            }
          });
          this.socketStore.setDeleteResult(deleteResult);
        },
        NoticeStatusChangeFinish(result) {
          this.socketStore.setDeleteStatus(JSON.parse(result[0]));
        },
        NoticeStockZeroResult(result) {
          const log = JSON.parse(result);
          this.socketStore.setSoldOutLog(log);
        },
        // 작업 결과 수신 (작업 ID 포함)
        WorkResult(payload) {
          const workId = payload[0];
          const result = payload[1];
          if (this.socketStore.workIdCallbacks.has(workId)) {
            this.socketStore.handleWorkResult(workId, result);
          }
        },
        // 재접속 업데이트 완료 알림
        ReconnectionUpdated(payload) {
          const updatedCount = payload[0];
          console.log(`재접속 업데이트 완료: ${updatedCount}개 작업`);
        }
      }
    });
  }
};
